import { ArticleParagraph2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC } from 'react';

import { ISwitchButton, TOptionValue } from './types';

import * as styles from './styles.css';

export const SwitchButton: FC<ISwitchButton> = props => {
  const { className, options, value, onClick } = props;

  const handleClick = (value: TOptionValue) => (event: React.SyntheticEvent<HTMLButtonElement, MouseEvent>) => {
    onClick(value, event);
  };

  return (
    <div className={clsx(styles['root'], className)} data-testid="switch-button">
      {options.map(option => (
        <button
          className={clsx(styles['button'], { [styles['selected']]: option.value === value })}
          key={`switch-button-${option.value}`}
          type="button"
          onClick={handleClick(option.value)}
        >
          <ArticleParagraph2>{option.title}</ArticleParagraph2>
        </button>
      ))}
    </div>
  );
};

SwitchButton.displayName = 'SwitchButton';
